module.exports = __webpack_public_path__ + "img/404-3.7f6ffaf2.gif";